import * as d3 from 'd3';

export default class Simulation {
  constructor(el) {
    this.el = el;

    this.container = d3.select(this.el);
    this.setDims();

    this.speed = 3;

    this.dest = Math.sqrt(this.width ** 2 + this.height ** 2);

    this.start();
  }

  setDims() {
    this.width = Math.floor(+this.container.style('width').replace('px', ''));
    this.height = Math.floor(+this.container.style('height').replace('px', ''));
  }

  updateSize() {
    setTimeout(() => {
      this.setDims();

      this.dest = Math.sqrt(this.width ** 2 + this.height ** 2);

      this.svg.attr('viewBox', `0 0 ${this.width} ${this.height}`);
      this.rect.attr('width', this.width).attr('height', this.height);
      this.g.attr('transform', `translate(${this.width / 2}, ${this.height / 2})`);
    }, 100);
  }

  start() {
    this.svg = this.container
      .append('svg')
      .attr('viewBox', `0 0 ${this.width} ${this.height}`)
      .style('width', '100%')
      .style('height', '100%');

    this.rect = this.svg
      .append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', this.width)
      .attr('height', this.height);

    this.g = this.svg
      .append('g')
      .attr('transform', `translate(${this.width / 2}, ${this.height / 2})`);

    this.myInt = setInterval(() => {
      try {
        this.starGenerator(this.g);
      } catch {
        clearInterval(this.myInt);
      }
    }, 5);
  }

  stop() {
    clearInterval(this.myInt);
  }

  starGenerator(g) {
    const size = Math.random() * 1.5 + 0.5;
    const starSpeed = Math.random() * 0.7 + 0.3;
    const angle = Math.random() * 2 * Math.PI;
    const origin = d3.pointRadial(angle, (Math.random() * this.width) / 2);
    const destination = d3.pointRadial(angle, this.dest);

    g.append('circle')
      .attr('fill', 'white')
      .attr('r', 0)
      .attr('cx', origin[0])
      .attr('cy', origin[1])
      .transition()
      .duration((10000 / this.speed) * starSpeed)
      .ease(d3.easeCubicIn)
      .attr('r', size * 8)
      .attr('cx', destination[0])
      .attr('cy', destination[1])
      .on('end', function() {
        d3.select(this).remove();
      });
  }
}
